import classNames from 'classnames'
import Text from 'components/Text'
import Accordion from 'components/Accordion'
import { ThemeContext } from 'modules/Theme'
import './LandingFaq.scss'
import { useContext } from 'react'

const LandingFaq = ({ blok }) => {
  const { theme } = useContext(ThemeContext)

  const isRecoveryOrigin = theme === 'recovery'

  const renderItems = () => {
    return blok.faqs.map((faq, index) => (
      <Accordion
        title={faq.question}
        className="faq-item"
        key={index}
        dataTest="faq-item"
        makeLocation="faq"
        makePosition="faq-item"
        MakeActionOutcome="clique"
        makeElement="button"
        makeText={faq.question}
        dataUnique={faq?.data_unique}
      >
        {faq?.answers?.map((answer, index) => (
          <Text
            p
            className={`faq-item__text ${
              faq?.answers?.length > 1 ? 'faq-item__spacing' : ''
            }`}
            data-test="faq-item__text"
            key={index}
          >
            {answer.answer}{' '}
            {answer.link ? (
              <a
                className="link-portal-faq"
                href={answer.link}
                aria-label={answer?.aria_label_link}
              >
                {answer.text_link}
              </a>
            ) : (
              ''
            )}
            {answer.answer_after_link ? answer.answer_after_link : ''}
          </Text>
        ))}
      </Accordion>
    ))
  }

  const faqClassnames = classNames('landing-faq', {
    'landing-faq__generalTheme': !isRecoveryOrigin,
  })

  return (
    <div className={faqClassnames} id="DuvidasFrequentes">
      <Text h2 className="faq-top-part">
        {blok.title}
      </Text>
      <div className="faq-middle-part">{renderItems()}</div>
    </div>
  )
}

export default LandingFaq
